import React, { FC } from 'react';
import Component, { Caption, Icon } from './styles';
import { Props } from './types';

const StatusButton: FC<Props> = ({ active, variant, onClick, ...props }) => {
  switch (variant) {
    case 'complete':
      return (
        <Component
          type="button"
          active={active}
          onClick={!active ? onClick : undefined}
          variant="complete"
          {...props}
        >
          <Caption>Completed</Caption>
          {active && <Icon />}
        </Component>
      );

    case 'pending':
      return (
        <Component
          type="button"
          active={active}
          onClick={!active ? onClick : undefined}
          variant="pending"
          {...props}
        >
          <Caption>Pending</Caption>
          {active && <Icon />}
        </Component>
      );

    case 'ready':
      return (
        <Component
          type="button"
          active={active}
          onClick={!active ? onClick : undefined}
          variant="ready"
          {...props}
        >
          <Caption>Ready</Caption>
          {active && <Icon />}
        </Component>
      );

    case 'cancelled':
      return (
        <Component as="div" variant="cancelled">
          <Caption>Cancelled</Caption>
        </Component>
      );

    default:
    case 'scheduled':
      return (
        <Component as="div" variant="scheduled">
          <Caption>Scheduled</Caption>
        </Component>
      );
  }
};

export default StatusButton;
